/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_Sync_ErrorInputs */

const cs_projects_sync_error = /** @type {(inputs: Projects_Sync_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chyba synchronizace`)
};

const en_projects_sync_error = /** @type {(inputs: Projects_Sync_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sync error`)
};

/**
* | output |
* | --- |
* | "Sync error" |
*
* @param {Projects_Sync_ErrorInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const projects_sync_error = /** @type {((inputs?: Projects_Sync_ErrorInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Sync_ErrorInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_projects_sync_error(inputs)
	return cs_projects_sync_error(inputs)
});